import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';

import { GlobalStyles } from './styles/GlobalStyles';
import { Navbar } from './components/landing/Navbar';
import { Footer } from './components/landing/Footer';
import Landing from './pages/Landing';

function App() {
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  return (
    <>
      <GlobalStyles />
      {isHomePage ? (
        <Landing />
      ) : (
        <>
          <Navbar />
          <Outlet />
          <Footer />
        </>
      )}
    </>
  );
}

export default App;
